import React, { useState, useEffect } from "react";
import {
  Select,
  Form,
  Input,
  Button,
  Row,
  DatePicker,
  message,
  Cascader,
} from "antd";
const { RangePicker } = DatePicker;
import DepartmentApi from "@api/department";
import moment from "moment";
import AddModal from "@components/Modal";
import InspectionApi from "@api/inspectionnew";
import { disabledDate, disabledTime } from "@utils/common";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
export default ({ title, visible, rowData = {}, cancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState();
  const [deptList, setDeptList] = useState([]);
  const [personList, setPersonList] = useState([]);
  const [timeLimit, setTimeLimit] = useState([]);

  useEffect(() => {
    getDept();
  }, [visible]);

  useEffect(() => {
    if (rowData.createAt) {
      setTimeLimit([rowData.createAt, rowData.planCloseTime]);
    }
  }, [rowData]);

  const getDept = async () => {
    // 查询部门
    const res = await DepartmentApi.getDeptForTree({});
    if (!res.status) return;
    setDeptList(res.data);
  };

  // 切换部门查询部门负责人
  const changeDept = (e) => {
    if (!e) return;
    getDeptUser(e[e.length - 1]);
  };

  const getDeptUser = (deptId) => {
    DepartmentApi.getUsersByDeptId({
      deptId,
      stationId: rowData.stationId,
    }).then((res) => {
      if (res.status !== "0") return;
      setPersonList(res.data);
    });
  };

  // 递归处理数据
  const getTreeData = (data) => {
    for (var i = 0; i < data.length; i++) {
      if (data[i].children.length < 1) {
        data[i].children = null;
        data[i].label = data[i].name;
        data[i].value = data[i].id;
      } else {
        data[i].label = data[i].name;
        data[i].value = data[i].id;
        getTreeData(data[i].children);
      }
    }
    return data;
  };

  // 提交
  const submit = () => {
    form.validateFields().then((values) => {
      if (!values) {
        return;
      }
      setLoading(true);
      const val = JSON.parse(JSON.stringify(values));
      let handleUserIds = "";
      val.acceptUserId.forEach((item) => {
        handleUserIds += item + ",";
      });
      let param = {
        instructTitle: val.instructTitle,
        instructContent: val.instructContent,
        beginTime: moment(val.times[0]).format("YYYY-MM-DD hh:mm:ss"),
        endTime: moment(val.times[1]).format("YYYY-MM-DD hh:mm:ss"),
        handleUserIds: handleUserIds.substring(0, handleUserIds.length - 1),
        stationId: rowData.stationId,
        sourceType: 0,
        sourceId: rowData.sourceId,
        defectOrderId: rowData.id,
        insertType: 1, // 新增类型:0-自动创建，1-手动创建 ,
      };
      InspectionApi.defectOrderInstructOrderAdd(param)
        .then((res) => {
          if (res.status == 0) {
            message.success("新建成功");
            handelCancel(true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    });
  };
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  };
  // 切换类型
  return (
    <AddModal
      title={title}
      footer={[
        <Row key={"btn"} span={24}>
          <Button
            key={1}
            onClick={() => handelCancel(false)}
            className="abuttons"
          >
            <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
          </Button>
          <Button
            key={2}
            loading={loading}
            onClick={submit}
            className="abuttons"
            type="primary"
          >
            <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
          </Button>
        </Row>,
      ]}
      visible={visible}
      width={600}
      okText={"确定"}
      onCancel={handelCancel}
      onSubmit={submit}
    >
      <div className="userModal">
        <Form
          {...layout}
          layout="horizontal"
          form={form}
          style={{ marginTop: "20px" }}
        >
          <Form.Item
            label="指令单标题"
            name="instructTitle"
            rules={[{ required: true, message: "请填写指令单标题" }]}
          >
            <Input placeholder="指令单标题" />
          </Form.Item>
          <Form.Item
            label="负责部门"
            name="deptId"
            rules={[{ required: true, message: "请选择负责部门" }]}
          >
            <Cascader
              fieldNames={{
                label: "name",
                value: "id",
                children: "children",
              }}
              options={deptList}
              onChange={(e) => {
                changeDept(e);
              }}
              placeholder="请选择"
            />
          </Form.Item>
          <Form.Item
            label="处理人"
            name="acceptUserId"
            rules={[{ required: true, message: "请选择处理人" }]}
          >
            <Select mode="multiple" placeholder="请选择处理人">
              {personList.length > 0 &&
                personList.map((item) => {
                  return (
                    <Select.Option value={item.id} key={item.id}>
                      {item.realName}
                    </Select.Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            label="截止时间"
            name="times"
            rules={[{ required: true, message: "请选择截止时间" }]}
          >
            <RangePicker
              disabledDate={(current) => disabledDate(current, timeLimit)}
              disabledTime={(current, type) =>
                disabledTime(current, type, timeLimit)
              }
              showTime
            />
          </Form.Item>
          <Form.Item
            label="指令单内容"
            name="instructContent"
            rules={[{ required: true, message: "请填写指令单内容" }]}
          >
            <Input.TextArea row={4} placeholder={"指令单内容"} />
          </Form.Item>
        </Form>
      </div>
    </AddModal>
  );
};
